// @ts-nocheck



import CommonApi from './../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

const convertDataToServer = (tripInspectionCost) => ({
  ...tripInspectionCost,
  cost: convertFromRubToKop(tripInspectionCost.cost)
});

const convertDataFromServer = (tripInspectionCost) => ({
  ...tripInspectionCost,
  cost: convertFromKopToRub(tripInspectionCost.cost)
});

const tripInspectionCost = new CommonApi(
  'tripInspectionCost',
  'Стоимость предрейсовых/послерейсовых осмотров',
  convertDataToServer,
  convertDataFromServer
);

export default {
  ...tripInspectionCost
};